import { CertificateStandardSource } from 'entities/certificate'

export type CertificateSource = Extract<
    CertificateStandardSource,
    'B_CORP' | 'ONE_PERCENT_FOR_THE_PLANET' | 'PLANET_MARK' | 'CLIMATE_NEUTRAL'
>

export const certificatesToDiscounts: Record<CertificateSource, number> = {
    B_CORP: 0.05,
    ONE_PERCENT_FOR_THE_PLANET: 0.05,
    PLANET_MARK: 0.025,
    CLIMATE_NEUTRAL: 0.025,
}
export type Discount = {
    name: CertificateSource
}
